module.exports = __webpack_public_path__ + "img/72category.bc25c3c8.svg";